export function getApiBaseUrl() {
    //return window.env?.REACT_APP_API_URL || "http://localhost:8000";
    //return process.env.REACT_APP_API_URL;
    return window.env.API_URL || "http://localhost:8000";
}